import { Paper, Stack, IconButton, Chip, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { AnonymousCustomersReport, CommitmentUsageReport, ContractsReport, MonthlyClosureReport, ProductsUsageReport, UnchargedUsageReport } from '@weft/types';
import { dayjs, isArray, isNotNullOrUndefined, isNullOrUndefined } from '@weft/utils';
import { useVyNavigate } from '../../../hooks/use-vy-navigate';

type Reports = CommitmentUsageReport | UnchargedUsageReport | ProductsUsageReport | ContractsReport | AnonymousCustomersReport | MonthlyClosureReport;

type ReportHeaderProps = {
  reportData: Reports;
  creationDate?: Date;
  startDate?: Date;
  endDate?: Date;
};
  
export const ReportHeader: React.FC<ReportHeaderProps> = ({ reportData, creationDate, startDate, endDate }) => {
  const navigate = useVyNavigate();

  const getFormattedDate = () => {
    if (isNotNullOrUndefined(startDate) && isNotNullOrUndefined(endDate)) {
      return `${formatHeaderDateWithoutTime(startDate)} — ${formatHeaderDateWithoutTime(endDate)}`;
    }
    if (isNullOrUndefined(startDate) && isNotNullOrUndefined(endDate)) {
      return `As of ${formatHeaderDate(endDate)}`;
    }
    if (isNotNullOrUndefined(creationDate)) {
      return `As of ${formatHeaderDate(creationDate)}`;
    }

    return '';
  };

  return (
    <Paper
      sx={{
        padding: 2,
        borderRadius: '8px',
        position: 'relative',
        width: '100%',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={1.5}
        >
          <IconButton
            sx={{ padding: '8px', backgroundColor: '#0D1B2714', borderRadius: '4px' }}
            onClick={() => navigate(-1)}

          >
            <VyIcon icon="ArrowSmallLeft" />
          </IconButton>
          <Typography
            variant="body1"
            fontWeight={400}
            fontSize="16px"
            lineHeight='24px'
            color='#0D1B27DE'
          >
            {getFormattedDate()}
          </Typography>
        </Stack>
        {isArray(reportData) && (<Chip label={`${reportData.length} items`} />)}
      </Stack>
    </Paper>
  );
};
  
export function formatHeaderDate(date: Date) {
  return dayjs(date).utc().format('DD MMMM YY HH:mm');
}

export function formatHeaderDateWithoutTime(date: Date) {
  return dayjs(date).utc().format('DD MMMM YYYY');
}
